// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.verify-email-container p[data-v-f553088e] {\n  font-size: 1.2rem !important;\n  color: var(--bluey-grey);\n}\n.verify-email-container span[data-v-f553088e] {\n  color: var(--sea);\n  font-weight: 600;\n}\n.verify-email-container span[data-v-f553088e]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
